<template>
  <div class="p-2">
    <transition
      name="fade"
      mode="out-in"
    >
      <NegociacaoGrid
        v-if="!showForm"
        @toggleForm="toggleForm"
      />
      <NegociacaoForm
        v-else
        :edit-id="editId"
        @cancelar="toggleForm(false)"
        @finalizado="toggleForm(false)"
      />
    </transition>
  </div>
</template>

<script>
import NegociacaoGrid from './grid/NegociacaoGrid.vue'
import NegociacaoForm from './form/NegociacaoForm.vue'

export default {
  name: 'NegociacaoMain',
  components: {
    NegociacaoGrid,
    NegociacaoForm,
  },
  data() {
    return {
      showForm: false,
      editId: null,
    }
  },
  methods: {
    toggleForm(val, id = null) {
      this.editId = id
      this.showForm = val
    },
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
